function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeywordsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 352.666 352.666",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005CB9"
    },
    d: "M253.149,308.053c0,13.75-11.25,25-25,25H25c-13.75,0-25-11.25-25-25V37.113 c0-13.75,11.25-25,25-25h203.149c13.75,0,25,11.25,25,25V308.053z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.476,
    y: 73.685,
    style: {
      fill: "#FFFFFF"
    },
    width: 152.199,
    height: 30.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.476,
    y: 197.268,
    style: {
      fill: "#1E252B"
    },
    width: 152.199,
    height: 15.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.452,
    y: 226.601,
    style: {
      fill: "#1E252B"
    },
    width: 116.246,
    height: 15.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3C6C8"
    },
    d: "M336.555,254.287H130.974c-21.281,0-38.533,17.253-38.533,38.533 c0,21.281,17.252,38.533,38.533,38.533h205.581V254.287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEE050"
    },
    d: "M343.468,340.553H130.974c-26.32,0-47.732-21.412-47.732-47.732 c0-26.319,21.412-47.732,47.732-47.732h212.494c5.08,0,9.198,4.118,9.198,9.199c0,5.081-4.118,9.199-9.198,9.199H130.974 c-16.175,0-29.335,13.159-29.335,29.334c0,16.175,13.16,29.335,29.335,29.335h212.494c5.08,0,9.198,4.118,9.198,9.198 C352.666,336.435,348.548,340.553,343.468,340.553z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.716,
    y: 276.359,
    style: {
      fill: "#7D868C"
    },
    width: 212.839,
    height: 4.293
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.716,
    y: 290.674,
    style: {
      fill: "#7D868C"
    },
    width: 212.839,
    height: 4.293
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.716,
    y: 304.988,
    style: {
      fill: "#7D868C"
    },
    width: 212.839,
    height: 4.293
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywordsIcon);
export default __webpack_public_path__ + "static/media/KeywordsIcon.ac4ede2bfe36c5eeff3facff11b5e8fb.svg";
export { ForwardRef as ReactComponent };